import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M8.798 1.737c.89 0 1.744.354 2.375.983l10.053 10.053a2.054 2.054 0 0 1 0 2.905l-5.982 5.983a2.054 2.054 0 0 1-2.905 0L2.286 11.606a3.361 3.361 0 0 1-.983-2.374v-5.44c0-1.135.92-2.055 2.054-2.055h5.441zm0 1.5h-5.44a.555.555 0 0 0-.555.554v5.441c0 .493.196.966.544 1.314L13.4 20.6a.554.554 0 0 0 .784 0l5.981-5.983a.554.554 0 0 0 0-.783L10.113 3.78a1.861 1.861 0 0 0-1.315-.544zm-2.18 1.76a2.055 2.055 0 1 1 0 4.11 2.055 2.055 0 0 1 0-4.11zm0 1.5a.555.555 0 1 0 .001 1.11.555.555 0 0 0 0-1.11z' />
  </svg>
);
